<template>
    <div class="our-team">
        <div class="our-team__content">
            <!-- Mobile Layout -->
            <section v-if="isMobile" class="our-team__mobile-section">
                <div class="container-fluid">
                    <!-- The Core Slider (Mobile) -->
                    <div class="row">
                        <div class="col-12">
                            <h2 class="our-team__section-title">The Core</h2>
                            <div class="our-team__carousel-wrapper">
                                <carousel :mouse-drag="false" :touch-drag="false" :autoplay="false" :loop="false"
                                    :nav="false" :margin="15" :dots="false" :items="2"
                                    :responsive="{ 361: { items: 2 }, 320: { items: 1 } }">
                                    <template slot="prev">
                                        <span class="our-team__arrow our-team__arrow--prev">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </span>
                                    </template>

                                    <div v-for="member in coreTeamData" :key="member.id"
                                        class="our-team__carousel-item">
                                        <div class="our-team__card">
                                            <div class="our-team__avatar-wrapper"
                                                :class="{ 'our-team__avatar-wrapper--active': isMemberActive(member) }"
                                                @click="selectMember(member)">
                                                <img :src="member.photo" :alt="member.name"
                                                    class="our-team__avatar-img" />
                                                <span class="our-team__member-label">{{ member.name }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <template slot="next">
                                        <span class="our-team__arrow our-team__arrow--next">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </span>
                                    </template>
                                </carousel>
                            </div>
                        </div>
                    </div>

                    <!-- Middle Content / Member Details (Mobile) -->
                    <div class="row py-4">
                        <div class="col-12 align-self-center">
                            <!-- Default Writeup -->
                            <article v-if="!selectedMemberInfoPopup" class="our-team__writeup">
                                <h1 class="our-team__writeup-title">we are lymphomap</h1>
                                <div class="our-team__writeup-body">
                                 <p><span>Lymphomap’s team</span> comprises those individuals who <span>march on the bridge to “tomorrow”.</span> At the heart of Lymphomap, there is ingenuity, creativity, and a futuristic approach to running a venture by utilizing <span>disruptive technologies</span> every day. As we <span>merge the worlds</span> of artificial intelligence and precision oncology, our core team strives to nurture an innovation that will be a <span>“one-click” solution</span> for the future of cancer.</p>
                                </div>
                            </article>

                            <!-- Member Detail Modal Box -->
                            <aside v-else v-click-outside="closeMemberInfo" class="our-team__info-overlay">
                                <div v-if="selectedMemberInfo" class="our-team__info-card">
                                    <button type="button" class="our-team__close-btn" aria-label="Close member bio"
                                        @click="closeMemberInfo">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                    <h2 class="our-team__info-name">
                                        {{ selectedMemberInfo.name }}
                                        <span v-if="selectedMemberInfo.id === 'core1'" class="our-team__info-tag">
                                            (in memoriam)
                                        </span>
                                    </h2>
                                    <h6 class="our-team__info-designation">{{ selectedMemberInfo.desgination }}</h6>
                                    <div class="our-team__info-bio" v-html="selectedMemberInfo.bioInfo"></div>
                                </div>
                            </aside>
                        </div>
                    </div>

                    <!-- The Experts Slider (Mobile) -->
                    <div class="row">
                        <div class="col-12">
                            <h2 class="our-team__section-title">The EXperts</h2>
                            <div class="our-team__carousel-wrapper">
                                <carousel :mouse-drag="false" :touch-drag="false" :autoplay="false" :loop="false"
                                    :nav="false" :margin="15" :dots="false" :items="2"
                                    :responsive="{ 361: { items: 2 }, 320: { items: 1 } }">
                                    <template slot="prev">
                                        <span class="our-team__arrow our-team__arrow--prev">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </span>
                                    </template>

                                    <div v-for="expert in expertsTeamData" :key="expert.id"
                                        class="our-team__carousel-item">
                                        <div class="our-team__card">
                                            <div class="our-team__avatar-wrapper"
                                                :class="{ 'our-team__avatar-wrapper--active': isMemberActive(expert) }"
                                                @click="selectMember(expert)">
                                                <img :src="expert.photo" :alt="expert.name"
                                                    class="our-team__avatar-img" />
                                                <span class="our-team__member-label">{{ expert.name }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <template slot="next">
                                        <span class="our-team__arrow our-team__arrow--next">
                                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        </span>
                                    </template>
                                </carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Desktop Layout -->
            <section v-else class="container-fluid our-team__desktop-section">
                <div class="row">
                    <!-- The Core (Vertical Hooper Carousel) -->
                    <div class="col-sm-3">
                        <h2 class="our-team__section-title">The Core</h2>
                        <div class="our-team__vertical-slider">
                            <hooper :vertical="true" :items-to-show="3" :items-to-slide="1" :touch-drag="false"
                                :mouse-drag="false" :wheel-control="true" :infinite-scroll="false"
                                :trim-white-space="true" :transition="400" class="our-team__hooper-instance">
                                <slide v-for="member in coreTeamData" :key="member.id">
                                    <div class="our-team__card">
                                        <div class="our-team__avatar-wrapper"
                                            :class="{ 'our-team__avatar-wrapper--active': isMemberActive(member) }"
                                            @click="selectMember(member)">
                                            <img :src="member.photo" :alt="member.name" class="our-team__avatar-img" />
                                            <span class="our-team__member-label">{{ member.name }}</span>
                                        </div>
                                    </div>
                                </slide>
                                <!-- <hooper-navigation slot="hooper-addons"></hooper-navigation> -->
                            </hooper>
                        </div>
                    </div>

                    <!-- Middle Description / Details View -->
                    <div class="col-sm-6 px-0 align-self-center"
                        :class="selectedMemberInfoPopup ? 'our-team--animate-fade' : 'our-team--animate-zoom'">
                        <!-- Default Writeup -->
                        <article v-if="!selectedMemberInfoPopup" class="our-team__writeup">
                            <h1 class="our-team__writeup-title">we are lymphomap</h1>
                            <div class="our-team__writeup-body">
                                <p><span>Lymphomap’s team</span> comprises those individuals who <span>march on the bridge to “tomorrow”.</span> At the heart of Lymphomap, there is ingenuity, creativity, and a futuristic approach to running a venture by utilizing <span>disruptive technologies</span> every day. As we <span>merge the worlds</span> of artificial intelligence and precision oncology, our core team strives to nurture an innovation that will be a <span>“one-click” solution</span> for the future of cancer.</p>
                            </div>
                        </article>

                        <!-- Member Detail Modal Box -->
                        <aside v-else v-click-outside="closeMemberInfo" class="our-team__info-container">
                            <div v-if="selectedMemberInfo" class="our-team__info-card">
                                <button type="button" class="our-team__close-btn" aria-label="Close member bio"
                                    @click="closeMemberInfo">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                                <h2 class="our-team__info-name">
                                    {{ selectedMemberInfo.name }}
                                    <span v-if="selectedMemberInfo.id === 'core1'" class="our-team__info-tag">
                                        (in memoriam)
                                    </span>
                                </h2>
                                <h6 class="our-team__info-designation">{{ selectedMemberInfo.desgination }}</h6>
                                <div class="our-team__info-bio" v-html="selectedMemberInfo.bioInfo"></div>
                            </div>
                        </aside>
                    </div>

                    <!-- The Experts (Vertical Hooper Carousel) -->
                    <div class="col-sm-3">
                        <h2 class="our-team__section-title">The EXperts</h2>
                        <div class="our-team__vertical-slider">
                            <hooper :vertical="true" :items-to-show="3" :items-to-slide="1" :touch-drag="false"
                                :mouse-drag="false" :wheel-control="true" :infinite-scroll="false"
                                :trim-white-space="true" :transition="400" class="our-team__hooper-instance">
                                <slide v-for="expert in expertsTeamData" :key="expert.id">
                                    <div class="our-team__card">
                                        <div class="our-team__avatar-wrapper"
                                            :class="{ 'our-team__avatar-wrapper--active': isMemberActive(expert) }"
                                            @click="selectMember(expert)">
                                            <img :src="expert.photo" :alt="expert.name" class="our-team__avatar-img" />
                                            <span class="our-team__member-label">{{ expert.name }}</span>
                                        </div>
                                    </div>
                                </slide>
                                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                            </hooper>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import 'hooper/dist/hooper.css';
import { Hooper, Navigation as HooperNavigation, Slide } from 'hooper';
import carousel from 'vue-owl-carousel';
import { bus } from '@/main';

import corePhoto1 from '@/assets/images/our_team/img_bio/rahul_sir.png';
import corePhoto2 from '@/assets/images/our_team/img_bio/aanchal_profile_pic_png.png';
import corePhoto3 from '@/assets/images/our_team/img_bio/dhanesh_img.png';
import corePhoto4 from '@/assets/images/our_team/img_bio/prince_photo.png';
import expertsPhoto1 from '@/assets/images/our_team/img_bio/dr_mallath_photo.png';
import expertsPhoto2 from '@/assets/images/our_team/img_bio/dr_reena_photo.png';
import expertsPhoto3 from '@/assets/images/our_team/img_bio/dr_vivek_photo.png';
import expertsPhoto4 from '@/assets/images/our_team/img_bio/dr_ptanakar_photo.png';
import expertsPhoto5 from '@/assets/images/our_team/img_bio/andrew_lee.png';
import expertsPhoto6 from '@/assets/images/our_team/img_bio/dr_anupam_mitra_photo.png';

export default {
    name: 'OurTeamPage',
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        carousel
    },
    data() {
        return {
            selectedMemberInfo: null,
            selectedMemberInfoPopup: false,
            isMobile: false,
            resizeTimer: null,
            coreTeamData: [
                // {
                //   id: 'core1',
                //   name: 'Rahul Bhattacharya',
                //   desgination: 'Co-Founder, Former Chief Science Officer, and Luminary',
                //   photo: corePhoto1,
                //   bioInfo: `<p>Rahul Bhattacharya was a futurist in every sense of the word. Throughout his extensive academic career, he trained to be a nuclear physicist and an Artificial Intelligence (AI) Engineer. Rahul’s dream and vision was to build the AIs of tomorrow and to not only see but portray a fusion of AI and quantum computing. Despite having an Honors Degree in Physics, a Master’s degree in Nuclear Physics, and an MBA in Finance, Rahul was a Renaissance man who foresaw the future as he embraced numerous scientific discoveries from our forefathers.</p>
                //   <p>In his “Past Life” he was an FX Options Trader, A Quant, a Financial Risk Engineer, Financial Derivatives Trader and a Machine Learning Programmer but in “This Life” he was a visionary who wanted to control the future’s AIs and master the three pillars of artificial general intelligence – the strong forms of AI – which are Machine Behavior, Machine Understanding, and Machine Consciousness.</p> 
                //   <p>Rahul’s mission in life was to perceive “what was going to happen on our planet 200 years from now and how we can build a better tomorrow for our children and their children to come?” His musings revolved around committing resources towards building space technologies in order to surmount interstellar barriers and truly connect with the cosmos.</p> 
                //   <p>But in order for us to achieve the next impossible tasks in life, it is our job to understand the very existence of Artificial Intelligence and make it the solution to eradicate many of our global society’s issues, and that was the innerworkings of Rahul Bhattacharya’s beautiful mind.</p>`
                // },
                {
                    id: 'core2',
                    name: 'Aanchal Bhattacharya',
                    desgination: 'Founder and CEO',
                    photo: corePhoto2,
                    bioInfo: `<p>Founder and CEO of LYMPHOMAP Inc., an Artificial Intelligence Powered Precision Oncology Ecosystem on the Cloud - connecting experts, research and cutting-edge tools to fight cancer. </p>
                    <p>Aanchal Bhattacharya has inspiration, ambition, and passion flowing through her veins. She seeks to travel to a new era well beyond this time.</p> 
                    <p>She holds a first-class Joint Honors Degree in History and Religious Studies from McGill University. She is also a Wasserman Scholar and has a Master's Degree from Tisch School of the Arts New York University.</p> 
                    <p>Life has thrown numerous curveballs her way, and as the world faces myriad forms of tragedy and suffering, Aanchal's journey has led her to step into the world of entrepreneurship, where the creation of an Artificial Intelligence-powered precision oncology ecosystem offers an opportunity to make the world a better place.</p>
                    <p>As Aanchal has always analysed humankind's evolutionary process, the progress of societies, and the histories of the world, she now marches on the bridge that will usher in a novel era. The future is here.</p>`
                },
                {
                    id: 'core3',
                    name: 'Dhanesh Prajapati',
                    desgination: 'Chief Artificial Intelligence Engineer',
                    photo: corePhoto3,
                    bioInfo: `<p>Dhanesh’s primary expertise is in developing Analogical Machine Learning algorithms and code and working with kernel methods. He is an expert in working with advanced and applied mathematical constructs used in data science, such as Topological Data Analysis and Similarity Matrices. As a former graduate researcher, Dhanesh has experience in developing numerical solvers for aerospace engineering problems using Python/C++. Additionally, he has worked on state of the art aerodynamic projects such as finding a unique and un-traditional spike design to reduce drag in hypersonic flow regime employing experiment and numerical simulation. Dhanesh is proficient in Python, C++, and Excel/VBA.</p>
          <p>Dhanesh has a B.Tech in Aeronautical Engineering from the Aeronautical Society of India and an M.Tech in Aerospace Engineering from IIT, Bombay.</p>
          <p>In his free time, Dhanesh is a proficient cook and enjoys making different kinds of recipes. He also is into bodybuilding and is a regular guest of the gym.</p>`
                },
                {
                    id: 'core4',
                    name: 'Prince Tiwari',
                    desgination: 'Chief Frontend Software Engineer',
                    photo: corePhoto4,
                    bioInfo: `<p>Prince’s primary expertise includes Vue.js, Nuxt.js, AngularJS, JavaScript, jQuery, HTML5, and CSS3/SASS. He is interested in working on anything to do with Frontend using JavaScript and frameworks. Prince develops pixel perfect responsive designs that work on all devices and platforms therefore ensuring a reactive frontend with dynamic content.</p>
          <p>Prince has a major passion for technology and is extremely flexible especially when it comes to developing different approaches for problem solving techniques. He also has a Multimedia Web Developer Diploma at Virtual Voyage Indore adding to his frontend related expertise.</p>
          <p>Prince’s mindset revolves around the world of coding and he strongly believes that the language is accessible to all; you just need to have patience and the zest to learn.</p>`
                }
            ],
            expertsTeamData: [
                // {
                //   id: 'experts6',
                //   name: 'Mr. Anupam Mitra',
                //   desgination: 'Senior Board Advisor',
                //   photo: expertsPhoto6,
                //   bioInfo: `<p>Global Financial and Capital Market Expert</p><p>Mumbai, India</p>`
                // },
                // {
                //   id: 'experts5',
                //   name: 'Andrew Lee',
                //   desgination: 'Senior Board Advisor',
                //   photo: expertsPhoto5,
                //   bioInfo: `<p>Head of Investments,</p><p>EURIZON Capital Hong Kong Limited</p>`
                // },
                {
                    id: 'experts1',
                    name: 'Dr. Mohandas Mallath',
                    desgination: 'Honorary Advisor',
                    photo: expertsPhoto1,
                    bioInfo: `<p>Dr. Mohandas Mallath is currently a senior consultant with the Tata Medical Centre (Kolkata) and has 35 years of experience in the management of digestive cancers in two of India’s leading tertiary cancer hospitals. His core skills are in clinical oncology, clinical nutrition and Gastrointestinal cancer prevention.</p>
          <p>Dr. Mallath advises the Lymphomap team on developing user friendly and robust medical AI interface and the AI powered family of smart clinical assistants, with the mother bot currently being developed. He is also advising the team on developing oncology practice on the cloud and assisting us in recognizing the “low-hanging” fruits that will assist Lymphomap in being a global leader in Clinical AI. Dr. Mallath further guides the team on understanding the world of telemedicine and how it paves the way into the future.</p>`
                },
                {
                    id: 'experts2',
                    name: 'Dr Reena Nair',
                    desgination: 'Honorary Advisor',
                    photo: expertsPhoto2,
                    bioInfo: `<p>Dr. Reena Nair is currently a Senior Consultant with Tata Medical Centre (Kolkata) and has over 32 years of experience in the management of Hemato-Lymphoid Oncology in two of India’s leading tertiary cancer hospitals. Her core skills are in Clinical oncology, while also assisting various reputed NGOs in developing state of the art patient and survivor support groups.</p>
          <p>Dr Nair advises the Lymphomap team on understanding the world of oncology, current issues, and roadblocks encountered in the industry, along with advising on Clinical AI in the field of oncology. She is also advising the team on the stratifying Big Data as we utilize AI and Machine Learning, while also guiding us on how to aptly provide patient and survivor support groups on the cloud with some of the top NGOs in the country.</p>
          <p>In Dr. Nair’s very own words she is “Born in the East, became a doctor in the West, belong to the North and married in South India… proud to be a true Indian.”</p>`
                },
                {
                    id: 'experts4',
                    name: '(Prof.) Dr. Prantar Chakrabarti',
                    desgination: 'Chief of Digital Health Advisory and Augmented Intelligence Advisory',
                    photo: expertsPhoto4,
                    bioInfo: `<p>Dr. Prantar Chakrabarti is currently the Director at the Department of Hematology, at AMRI Hospital (Kolkata). He is also the Head of Clinical Content and Healthcare data for Novel Medicare Solutions Private Limited and is adjunct faculty of the School of Biological Sciences at Ramakrishna Mission Vivekananda Educational and Research Institute (RKMVERI). To add, to Dr. Prantar’s long list of accolades, he is also a senior consultant at the Center of Digital Healthcare Technologies at the Maulana Abul Kalam University of Technology (West Bengal), an active member of the Scientific Advisory Committee at the National Institute of Immunohematology (ICMR) in Mumbai and he is also a member of the Institutional Ethics Committee at Indian Institute of Technology (IIT) Kharagpur.</p>
          <p>Dr. Prantar’s passion is to provide quality and affordable healthcare by incorporating digital health that uses data science and artificial intelligence. Additionally, Dr. Prantar strives to work with dedicated healthcare providers to lessen the significant gaps in healthcare delivery systems in low and middle-income countries.</p>
          <p>Dr. Prantar advises the Lymphomap team on how to efficiently build a robust digital healthcare platform in order for professionals in the industry to utilize Artificial Intelligence (AI) and Machine Learning models seamlessly and to its full advantage. He is also advising the team on how to efficiently “digitize” healthcare features for professionals while stratifying Big Data.</p>
          <p>In his free time, Dr. Chakrabarti loves acting and directing. As part of his reveries, Dr. Chakrabarti envisions of making a film on cancer warriors.</p>`
                },
                {
                    id: 'experts3',
                    name: 'Dr. Vivek Radhakrishnan',
                    desgination: 'Honorary Advisor',
                    photo: expertsPhoto3,
                    bioInfo: `<p>Dr. Vivek Radhakrishnan is a Haemato-Oncologist and Transplant physician at Tata Medical Centre (Kolkata) with expertise in comprehensive cancer care, hemato-oncology, immunotherapy, targeted therapies, clinical research, prospective trials, and audits. Dr. Vivek is also the joint secretary of the Immuno-Oncology Society of India and a member of International and National Oncology and Hematology professional societies like the ASCO, ESMO, ASH, EBMT, etc. To his credit, he has multiple merit based international academic visiting-fellowships at specialized centers. Dr. Vivek is also an alumnus of the reputed ACORD research workshops, Sydney, and healthcare management program at the Darden Business School, Univ. of Virginia.</p>
          <p>Dr. Vivek is actively involved in precision medicine approaches and methodologies and his area of expertise includes multi-modality chemotherapy, targeted therapies, immunotherapy and hematopoietic cell transplantation in hematological cancers. In his own words, Dr. Vivek mentions, “Over the years, I have been able to establish or expand these programs at my workplace. Apart from leading the transplant programs, I have been involved directly in the initiation and/or conduct of investigator-initiated and pharma-sponsored clinical studies.” His areas of interest also revolve around patient centric prospective and real-world data, clinical research, and therapy development.</p>
          <p>Dr. Vivek continues to advise the Lymphomap team on how to implement AI into the field of precision medicine including patient treatment protocols, novel therapies and clinical decision-making using AI and Machine Learning.</p>
          <p>In his free time Dr. Vivek indulges in current affairs, music, and clay-modeling (primarily with his kids).</p>`
                },
            ]
        };
    },
    created() {
        this.handleResize();
        window.addEventListener('resize', this.onResize, { passive: true });
    },
    mounted() {
        document.body.classList.add('public_page_for_wrp_img');
        bus.$emit('showHeaderbtn', false);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        document.body.classList.remove('public_page_for_wrp_img');
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 1024;
        },
        onResize() {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.handleResize();
            }, 100);
        },
        isMemberActive(member) {
            return this.selectedMemberInfo && this.selectedMemberInfo.id === member.id;
        },
        selectMember(item) {
            this.selectedMemberInfo = item;
            this.selectedMemberInfoPopup = true;
            if(this.isMobile) {
                document.body.classList.add('no-scroll', 'our_team_page'); // Disable scrolling when popup is open
            }
        },
        closeMemberInfo() {
            this.selectedMemberInfoPopup = false;
            this.selectedMemberInfo = null;
            if(this.isMobile) {
                document.body.classList.remove('no-scroll', 'our_team_page'); // Re-enable scrolling when popup is closed
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

// --- Design Tokens ---
$font-main: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;

$color-bg-base: #0a0d14;
$color-card-bg: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);
$color-card-border: rgba(255, 255, 255, 0.08);
$color-card-border-active: rgba(255, 212, 0, 0.6);

$color-primary: #ffd400; // Yellow primary
$color-primary-glow: rgba(255, 212, 0, 0.25); // Soft yellow glow
$color-accent: #818cf8; // Indigo accent
$color-highlight: #facc15; // Soft gold highlight

$color-text-main: #f8fafc;
$color-text-sub: #cbd5e1;
$color-text-muted: #94a3b8;
$color-danger: #f87171;

.our-team {
  min-height: 100dvh;
//   background: radial-gradient(circle at 50% 20%, #151d30 0%, $color-bg-base 100%);
  position: relative;
  font-family: $font-main;
  color: $color-text-main;
  overflow-x: hidden;
  padding:70px 0px 8px;
  @media (max-width: 768px) {
    padding: 60px 0 8px;
  }

  &__content {
    background: rgba(0, 0, 0, 0.7);
    padding:10px 0;

  }

  // --- Section Titles ---
  &__section-title {
    font-size: 1.8rem;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    text-align: center;
    color: #fffc00;
    margin-bottom: 0.5rem;
    // background: linear-gradient(135deg, #ffffff 30%, $color-primary 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    font-family: 'origin_tech_demoregular', $font-main;
  }

  // --- Vertical Slider Container ---
  &__vertical-slider {
    position: relative;
    ::v-deep .hooper-list{padding-top: 0.5rem;}

    ::v-deep .hooper-navigation {
      button {
        background: rgba(255, 255, 255, 0.1) !important;
        backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.15) !important;
        border-radius: 50% !important;
        width: 32px !important;
        height: 32px !important;
        fill: $color-primary !important;
        right: 10px !important;
        left: auto !important;
        transition: all 0.25s ease;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 0;

        &:hover:not(.is-disabled) {
          background: $color-primary !important;
          fill: #000 !important;
          box-shadow: 0 0 12px $color-primary-glow;
        }

        &.is-disabled {
          opacity: 0.2;
          cursor: not-allowed;
        }
        svg{width: 32px;height: 32px;}
      }

      .hooper-next {
        bottom: 45% !important;
      }
      .hooper-prev {
        top: 42% !important;
        @media only screen and (max-width:1290px) and (min-width:1260px) and (max-height:699px) {
         top: 39% !important;
        }
      }
    }
  }

  &__hooper-instance {
    height: calc(100dvh - 140px) !important;
  }

  // --- Member Cards & Avatars ---
 // --- Member Cards & Avatars ---
  &__card {
    text-align: center;
    padding: 10px 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
&__avatar-wrapper {
  width: 170px;
  height: 170px;
  min-width: 170px;
  min-height: 170px;
  aspect-ratio: 1 / 1;
  position: relative;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid $color-card-border;
  background: linear-gradient(
    -30deg,
    rgba(37, 44, 84, 0.8) 0%,
    rgba(0, 0, 0, 0.8) 50%,
    rgba(38, 38, 38, 0.8) 50%,
    rgba(44, 44, 84, 0.8) 100%
  );
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);

  // WebKit clipping & GPU fix (prevents oval distortion/sharp corners on Safari/macOS)
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  mask-image: radial-gradient(white, black);
  transform: translateZ(0);

  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              border-color 0.35s ease,
              box-shadow 0.35s ease;

  @media only screen and (max-width: 1290px) and (min-width: 1260px) and (max-height: 699px) {
    width: 130px;
    height: 130px;
    min-width: 130px;
    min-height: 130px;
  }

  @media (max-width: 768px) {
    width: 115px;
    height: 115px;
    min-width: 115px;
    min-height: 115px;
  }

  // Default image state
  .our-team__avatar-img {
    filter: grayscale(100%) opacity(0.85);
    transition: filter 0.35s ease, opacity 0.35s ease, transform 0.35s ease;
  }

  // Hover & Active state
  &:hover,
  &--active {
    transform: translateY(-4px) scale(1.03) translateZ(0);
    border-color: $color-primary;
    box-shadow: 0 0 20px $color-primary-glow, 0 12px 30px rgba(0, 0, 0, 0.6);

    .our-team__member-label {
      transform: translateY(0);
      opacity: 1;
    }

    .our-team__avatar-img {
      filter: grayscale(0%) opacity(1);
      transform: scale(1.05);
    }
  }

  // Active ring
  &--active {
    border-color: $color-primary;
    box-shadow: 0 0 0 3px rgba(255, 212, 0, 0.35), 0 0 24px $color-primary-glow;
  }
}

&__avatar-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  display: block;
  border-radius: 50%;
}

&__member-label {
  position: absolute;
  inset: auto 0 0 0;
  background: linear-gradient(180deg, rgba(10, 13, 20, 0) 0%, rgba(10, 13, 20, 0.95) 80%);
  transform: translateY(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  opacity: 0;
  pointer-events: none;
  padding: 10px 20px 25px;
  font-size: 14px;
  font-weight: normal;
  color: #fffc00;
  line-height: 1.3;
  -webkit-text-stroke: 0.2px #000;
  text-shadow: 0 0 4px #000000, 1px 1px 5px rgba(0, 0, 0, 0.6);
  font-family: 'origin_tech_demoregular', $font-main;

  @media only screen and (max-width: 1290px) and (min-width: 1260px) and (max-height: 699px) {
    padding: 10px 15px 25px;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 8px 15px 20px;
  }
}

  // --- Center Overview Writeup ---
  &__writeup {
    text-align: center;
    max-width: 680px;
    margin: 0 auto;
  }

  &__writeup-title {
    font-size: 3rem;
    font-weight: normal;
    letter-spacing: 0.01em;
    line-height: 1;
    // background: linear-gradient(135deg, #ffffff 40%, $color-primary 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    color: #fffc00;
    text-shadow: 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000, 0 0 4px #000;
    margin-bottom: 20px;
    font-family: 'origin_tech_demoregular', $font-main;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  &__writeup-body {
    background: $color-card-bg;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(93, 93, 93, 0.4);
    box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.1);
    padding:22px;
    border-radius: 16px;
    transition: border-color 0.3s ease;
    @media only screen and (max-width: 768px) {
      padding: 15px;
    }

    &:hover {
      border-color: rgba(255, 255, 255, 0.15);
    }

    p {
      font-size: 1.05rem;
      color: $color-text-sub;
      line-height: 1.75;
      margin: 0;
      @media only screen and (max-width: 768px) {
      font-size: 1rem;
      line-height: 1.6;
      }

      span {
        color: #ffffff;
        font-weight: 600;
        // border-bottom: 1px solid rgba(255, 212, 0, 0.4);
      }
    }
  }

  // --- Member Detail Modal / Sidebar Card ---
  &__info-container {
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
  }

  &__info-overlay {
    position: fixed;
    inset: 0;
    z-index: 1050;
    background: rgba(5, 8, 15, 0.8);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  &__info-card {
    background: linear-gradient(-30deg, rgba(37, 44, 84, 0.8) 0%, rgba(0, 0, 0, 0.8) 50%, rgba(38, 38, 38, 0.8) 50%, rgba(44, 44, 84, 0.8) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(93, 93, 93, 0.4);
    box-shadow: 0 5px 10px 0 rgba(244, 242, 238, 0.1);
    padding: 20px 28px 24px;
    border-radius: 18px;
    position: relative;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    @media only screen and (max-width: 768px) {
      padding: 20px 15px;
    }
  }

  &__info-name {
    font-size: 1.75rem;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.25;
    margin: 0 0 6px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      font-size: 1.35rem;
    }
  }

  &__info-tag {
    font-size: 0.75rem;
    font-weight: 500;
    color: $color-highlight;
    background: rgba(255, 212, 0, 0.12);
    border: 1px solid rgba(255, 212, 0, 0.3);
    padding: 2px 8px;
    border-radius: 12px;
    letter-spacing: 0.02em;
  }

  &__info-designation {
    color: $color-primary;
    font-size: 0.95rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    margin: 0 0 16px;
  }

  &__info-bio {
    overflow-y: auto;
    color: $color-text-sub;
    line-height: 1.7;
    padding-right: 12px;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.15);

      &:hover {
        background: rgba(255, 255, 255, 0.25);
      }
    }

    ::v-deep p {
      margin-bottom: 14px;
      font-size: 0.95rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-text-muted;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(248, 113, 113, 0.15);
      border-color: $color-danger;
      color: $color-danger;
      transform: rotate(90deg);
    }
  }

  // --- Mobile Carousel & Navigation ---
  &__carousel-wrapper {
    position: relative;
    padding: 0 30px;
  }

  &__carousel-item {
    padding: 6px;
  }

  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transition: all 0.2s ease;

    .fa {
      font-size: 1.25rem;
      color: #ffd400;
      transition: color 0.2s ease;
    }

    &:hover {
      background: $color-primary;
      border-color: $color-primary;

      .fa {
        color: #000;
      }
    }

    &--prev {
      left: 0px;
    }

    &--next {
      right: 0px;
    }
  }

  // --- Smooth Animations ---
  &--animate-fade {
    animation: modernFade 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  &--animate-zoom {
    animation: modernZoom 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
}

@keyframes modernFade {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes modernZoom {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<style lang="scss" scoped>
.our_team_page{
  .our-team{z-index: 1001;}
}
</style> 